import { render, staticRenderFns } from "./DevClassForm.vue?vue&type=template&id=0c9c0c61&"
import script from "./DevClassForm.vue?vue&type=script&lang=js&"
export * from "./DevClassForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports